const contactRouter = 
  {
    title: '咨询留言',
    type: 'view',
    name: 'contact',
    route: '/contact',
    filePath: 'view/contact/contact-list.vue',
    inNav: true,
    icon: 'iconfont icon-jiemiansheji',
  }

export default contactRouter
